import { Injectable } from '@angular/core';
import { Actions, createEffect } from '@ngrx/effects';
import type { Observable } from 'rxjs';
import { Action } from '@ngrx/store';
import { filter, tap } from 'rxjs/operators';
import { ValidateJWTError } from './auth.actions';
import { ConfigManagerService } from '../../shared/services/config-manager.service';
import { LocalStorageService } from 'ngx-webstorage';

@Injectable()
export class AuthEffects {
    constructor(
        private actions$: Actions,
        private configManagerService: ConfigManagerService,
        private storage: LocalStorageService
    ) {}

    validateError$ = createEffect(
        () =>
            this.actions$.pipe(
                filter((action: Action) => action instanceof ValidateJWTError),
                tap((action: ValidateJWTError) => {
                    try {
                        this.storage.clear();
                        this.configManagerService.doAuthenticationRedirect(
                            action.payload
                        );
                    } catch (err) {
                        console.error('Auth side effect failed: ', err);
                    }
                })
            ),
        { dispatch: false }
    );
}
